import { useForm } from "react-hook-form";
import { CommonFormContext } from "./CommonForm.context";

interface ICommonFormProvider {
  children: React.ReactNode;
}

// Form 데이터 관리
const CommonFormProvider = ({ children }: ICommonFormProvider) => {
  const {
    register,
    setValue,
    getValues,
    formState: { errors, ...rest },
    handleSubmit,
    reset,
    watch,
    control,
  } = useForm();
  const value = {
    register,
    setValue,
    getValues,
    formState: rest,
    handleSubmit,
    reset,
    watch,
    control,
    errors,
  };
  const state = {};

  return (
    <CommonFormContext.Provider value={value}>
      {children}
    </CommonFormContext.Provider>
  );
};

export default CommonFormProvider;
